import moment from 'moment-timezone';

const toStoreMoment = (value, timeZone) =>
  timeZone ? moment.tz(value, timeZone) : moment(value);

const toVoucherDate = (dateValue, timestamp, timeZone) => {
  if (dateValue) return toStoreMoment(dateValue, timeZone);
  if (timestamp) return toStoreMoment(Number(timestamp), timeZone);
  return null;
};

const toSeconds = (value) =>
  value === '' || value == null ? NaN : Number(value);

export const getVoucherCheckMoment = (currentOrder, timeZone) => {
  if (currentOrder?.isFutureDeliveryDate && currentOrder?.deliveryDate) {
    return timeZone
      ? moment.tz(currentOrder.deliveryDate, 'YYYY-MM-DD HH:mm', timeZone)
      : moment(currentOrder.deliveryDate, 'YYYY-MM-DD HH:mm');
  }
  return timeZone ? moment.tz(timeZone) : moment();
};

/**
 * Whether a voucher's weekday, start/end date and start/end time rules
 * allow it at `checkMoment` (a moment in the store's timezone).
 */
export default function isVoucherAvailableAt(voucher, checkMoment, timeZone) {
  if (!voucher || !checkMoment) return false;

  if (voucher[checkMoment.format('dddd')] === false) return false;

  const start = toVoucherDate(
    voucher.startDate,
    voucher.startDateTimestamp,
    timeZone
  );
  if (start?.isValid() && checkMoment.isBefore(start, 'day')) return false;

  const end = toVoucherDate(voucher.endDate, voucher.endDateTimestamp, timeZone);
  if (end?.isValid() && checkMoment.isAfter(end, 'day')) return false;

  const startTime = toSeconds(voucher.startTime);
  const endTime = toSeconds(voucher.endTime);
  if (
    voucher.isAvailableFullDay === false &&
    Number.isFinite(startTime) &&
    Number.isFinite(endTime)
  ) {
    const secondsOfDay =
      checkMoment.hours() * 3600 +
      checkMoment.minutes() * 60 +
      checkMoment.seconds();
    // An end before the start means the slot runs past midnight.
    const isInSlot =
      startTime <= endTime
        ? secondsOfDay >= startTime && secondsOfDay <= endTime
        : secondsOfDay >= startTime || secondsOfDay <= endTime;
    if (!isInSlot) return false;
  }

  return true;
}
